module.exports = __webpack_public_path__ + "static/media/pn.97f773ca.svg";